﻿import {ReactNode, RefObject, useEffect, useRef, useState} from "react";

export interface UseHasContentResult<T extends HTMLElement = HTMLElement> {
	ref: RefObject<T | null>;
	hasContent: boolean;
}

/**
 * Hook to check if a component has any content.
 * @param children The children to check.
 * @returns An object containing the ref and a boolean indicating whether the component has content.
 */
export function useHasContent<T extends HTMLElement = HTMLElement>(children: ReactNode): UseHasContentResult<T> {
	const ref = useRef<T>(null);
	const [hasContent, setHasContent] = useState(true);

	useEffect(() => {
		if (ref.current) {
			setHasContent(ref.current.textContent?.trim() !== "");
		}
	}, [children]);

	return {ref, hasContent};
}
